module.exports = __webpack_public_path__ + "img/XGUI_watch_system.0d54eb9a.png";